import {useApiUser} from "@/composables/useApiUser";
import { routes } from "@/config/routes";

export default defineNuxtRouteMiddleware((to, from) => {

    const user = useApiUser();

    let route = routes.find((r) => r.url === to.path);

    if(!route) {
        return;
    }

    if(route.url === '/login') {
        return;
    }

    if(user.value?.all_permissions) {
        if(user.value?.all_permissions?.map((p) => p.name).includes('system.admin.override')) {
            return;
        }
    }

    if(typeof route.permissions === 'undefined' || route.permissions === null || route.permissions.length === 0) {
        return;
    }

    if(user.value?.all_permissions) {
        if(route.permissions.some((p) => user.value?.all_permissions.map(perm => perm.name).includes(p))) {
            return;
        }
    }

    if(route.url === '/') {
        return navigateTo('/dashboard');
    }

    return navigateTo('/error/403');
})
